import React from "react";
import "./PropertyLocation.css";
import Slider from "react-slick";
import {
  FaLocationDot,
  FaDownload,
  FaRupeeSign,
  FaBuilding,
  FaCalendar,
  FaExpand,
  FaLayerGroup,
  FaRegHeart,
  FaBus,
  FaTrainSubway,
  FaHospital,
  FaArrowLeft,
  FaArrowRight,
} from "react-icons/fa6";
import { MdOutlineLocalMall } from "react-icons/md";
import MoreProperty from "./MoreProperty";


const nearbyPlaces = [{
    id: 1,
    icon: <FaBus />,
    title: "Bus Stand",
    place: "blatala Bus Stop",
    time: "3 mins",
    distance: "(1.2 km)",
  },
  {
    id: 2,
    icon: <FaTrainSubway />,
    title: "Metro Station",
    place: "Titumir Metro Station",
    time: "4 mins",
    distance: "(2.7 km)",
  },
  {
    id: 3,
    icon: <FaHospital />,
    title: "Hospital",
    place: "ILS Hospitals, Dumdum",
    time: "8 mins",
    distance: "(3.4 km)",
  },
  {
    id: 4,
    icon: <MdOutlineLocalMall  />,
    title: "Mall",
    place: "City Center 2",
    time: "10 mins",
    distance: "(4.1 km)",
  },
];



const PropertyLocation = ({ property }) => {

    function PrevArrow(props) {
  const { onClick } = props;

  return (
    <button className="spd-slider-arrow spd-prev-arrow" onClick={onClick}>
      <FaArrowLeft />
    </button>
  );
}

function NextArrow(props) {
  const { onClick } = props;

  return (
    <button className="spd-slider-arrow spd-next-arrow" onClick={onClick}>
      <FaArrowRight />
    </button>
  );
}

      const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div className="spd-main-wrapper">
      {/* <div className="home2-green-light"></div> */}
      <div className="home2-orange-light"></div>
      {/* LEFT CONTENT */}
      <div className="spd-left-section">
        {/* LOCATION CARD */}
        <div className="spd-location-card">
          <div className="spd-location-top">
            <div className="spd-location-icon">
              <FaLocationDot />
            </div>

            <div>
              <p className="spd-location-label">Property Location</p>
              <h3>New Town, Kolkata</h3>
            </div>
          </div>

          <div className="spd-around-project">
            <h4>Around This Project</h4>

            {/* <div className="spd-nearby-wrapper">
              <div className="spd-nearby-card">
                <div className="spd-nearby-icon">
                  <FaBus />
                </div>

                <div>
                  <p>Bus Stand</p>
                  <span>blatala Bus Stop</span>
                </div>
              </div>

              <div className="spd-nearby-card">
                <div className="spd-nearby-icon">
                  <FaTrainSubway />
                </div>

                <div>
                  <p>Metro Station</p>
                  <span>Titumir Metro Station</span>
                </div>

                <h5>
                  4 mins
                  <span>(2.7 km)</span>
                </h5>
              </div>
            </div> */}
              <Slider {...settings} className="spd-nearby-slider">
        {nearbyPlaces.map((item) => (
          <div key={item.id} className="spd-slide-padding">
            <div className="spd-nearby-card">
              <div className="spd-nearby-left">
                <div className="spd-nearby-icon">{item.icon}</div>

                <div>
                  <p>{item.title}</p>
                  <span>{item.place}</span>
                </div>
              </div>

              <h5>
                {item.time}
                <span>{item.distance}</span>
              </h5>
            </div>
          </div>
        ))}
      </Slider>

            <button className="spd-map-btn">
              View more on Maps
            </button>
          </div>
        </div>

        {/* OVERVIEW CARD */}
        <div className="spd-overview-card">
          <div className="spd-overview-header">
            <h2>Bhawani Paraiso Overview</h2>

            <button className="spd-download-btn">
              <FaDownload />
              Download Brochure
            </button>
          </div>

          <div className="spd-overview-grid">
            <div className="spd-overview-item">
              <FaBuilding />
              <div>
                <p>Project Units</p>
                <h4>324</h4>
              </div>
            </div>

            <div className="spd-overview-item">
              <FaExpand />
              <div>
                <p>Area Unit</p>
                <h4>sq.ft.</h4>
              </div>
            </div>

            <div className="spd-overview-item">
              <FaLayerGroup />
              <div>
                <p>Project Area</p>
                <h4>2.6 Acres</h4>
              </div>
            </div>

            <div className="spd-overview-item">
              <FaExpand />
              <div>
                <p>Sizes</p>
                <h4>1068 - 2271 sq.ft.</h4>
              </div>
            </div>

            <div className="spd-overview-item">
              <FaBuilding />
              <div>
                <p>Project Size</p>
                <h4>3 Buildings - 324 units</h4>
              </div>
            </div>

            <div className="spd-overview-item">
              <FaCalendar />
              <div>
                <p>Launch Date</p>
                <h4>Jun, 2025</h4>
              </div>
            </div>

            <div className="spd-overview-item">
              <FaRupeeSign />
              <div>
                <p>Avg. Price</p>
                <h4>₹71K/sq.ft</h4>
              </div>
            </div>

            <div className="spd-overview-item">
              <FaBuilding />
              <div>
                <p>Configurations</p>
                <h4>2, 3, 4 BHK Apartments</h4>
              </div>
            </div>
          </div>

          <div className="spd-rera-box">
            <p>Rera Id</p>
            <h5>WBRERA/P/NOR/2025/003627</h5>

            <button>Know More</button>
          </div>

          <div className="spd-bottom-actions">
            <button>Share</button>
            <button>Save</button>
            <button className="spd-primary-btn">
              Get Full Details
            </button>
          </div>
        </div>
        <MoreProperty property={property} />
      </div>

      {/* RIGHT CONTACT */}
      <div className="spd-contact-wrapper">
        <div className="spd-choice-box">
          Nice choice. Let’s connect with the Developer
        </div>

        <div className="spd-contact-card">
          <h3>Contact Seller</h3>

          <div className="spd-seller-box">
            <div className="spd-seller-logo">B</div>

            <div>
              <h4>Bhawani Group</h4>
              <p>Developer</p>
              <span>+9196742....</span>
            </div>
          </div>

          <h5>Please share your contact</h5>

          <div className="spd-form-group">
            <input type="text" placeholder="Name" />
          </div>

          <div className="spd-form-group">
            <div className="spd-phone-input">
              <span>+91</span>
              <input type="text" placeholder="Phone" />
            </div>
          </div>

          <div className="spd-form-group">
            <input type="email" placeholder="Email" />
          </div>

          <div className="spd-checkbox">
            <input type="checkbox" checked readOnly />
            <p>
              I agree to be contacted by Housing and agents via
              WhatsApp, SMS, phone, email etc
            </p>
          </div>

          <div className="spd-checkbox">
            <input type="checkbox" />
            <p>I am interested in Home Loans</p>
          </div>

          <button className="spd-contact-btn2">
            Get Contact Details
          </button>

          <div className="spd-shortlist-box">
            <div>
              <h4>Still deciding?</h4>
              <p>
                Shortlist this property for now & easily come
                back to it later.
              </p>
            </div>

            <button>
              <FaRegHeart />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyLocation;